var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLikeBordered = function SvgIconLikeBordered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m11.672 19.268.002.002.33.296.322-.286.002-.002c3.106-2.776 5.512-4.93 7.167-6.923C21.128 10.39 21.8 8.85 21.8 7.338 21.8 4.925 19.893 3 17.355 3c-1.448 0-2.86.673-3.768 1.72L12 6.556 10.412 4.72A5.08 5.08 0 0 0 6.645 3C4.106 3 2.2 4.925 2.2 7.338c0 1.511.671 3.052 2.303 5.015 1.655 1.991 4.062 4.144 7.169 6.915m2.053 1.578-.787.7a1.41 1.41 0 0 1-1.874-.004l-.79-.707-.01-.009C4.14 15.365.1 11.76.1 7.338.1 3.733 2.98.9 6.645.9A7.16 7.16 0 0 1 12 3.346 7.156 7.156 0 0 1 17.355.9C21.02.9 23.9 3.733 23.9 7.338c0 4.415-4.03 8.016-10.136 13.473z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLikeBordered;